export default __webpack_public_path__ + "static/media/art-museum.24d4df87.svg";